
$(".logo-slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    centerMode: true,
    speed: 5000,
    autoplaySpeed: 0,
    lazyLoad: 'ondemand',
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          speed: 3000,
        },
      },
    ],
  });

$(".top-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<div class="custom-arrow-prev"></div>',
  nextArrow: '<div class="custom-arrow-next"></div>',
  dots: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 799,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
});


$(".fs-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  cssEase: "linear",
  dots: true,
  arrows: true,
  prevArrow: '<div class="fp-custom-arrow-prev"></div>',
  nextArrow: '<div class="fp-custom-arrow-next"></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
      },
    },
  ],
});

// $('.farm-slider').slick({
//   centerMode: true,
//   centerPadding: '60px',
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   dots: true,
//   infinite: true,
//   speed: 500,
//   //fade: true,
//   arrows: false,
//   lazyLoad: 'ondemand',
//   cssEase: "linear",
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });



// Farm Slider - Initialize directly like other sliders
function updateFarmSlideSizes() {
  var $slider = $('.farm-slider');
  if (!$slider.length || !$slider.hasClass('slick-initialized')) return;
  
  var $slides = $slider.find('.slick-slide:not(.slick-cloned)'); // Original slides only
  var $allSlides = $slider.find('.slick-slide'); // All slides including clones
  var totalSlides = $slides.length;
  
  if (totalSlides === 0) return;
  
  // Remove all size classes first
  $allSlides.removeClass('size-center size-adjacent size-outer');
  
  // Find the center slide
  var $center = $allSlides.filter('.slick-center').first();
  if (!$center.length) return;
  
  var centerIndex = parseInt($center.attr('data-slick-index'));
  if (isNaN(centerIndex)) return;
  
  // Calculate adjacent indices with proper wrapping
  var leftAdjacentIndex = (centerIndex - 1 + totalSlides) % totalSlides;
  var rightAdjacentIndex = (centerIndex + 1) % totalSlides;
  
  // Apply classes to ALL slides (including clones) based on their data-slick-index
  $allSlides.each(function() {
    var $slide = $(this);
    var slideIndex = parseInt($slide.attr('data-slick-index'));
    
    if (isNaN(slideIndex)) return;
    
    // Normalize the index for comparison
    var normalizedIndex = ((slideIndex % totalSlides) + totalSlides) % totalSlides;
    var normalizedCenter = ((centerIndex % totalSlides) + totalSlides) % totalSlides;
    var normalizedLeftAdj = ((leftAdjacentIndex % totalSlides) + totalSlides) % totalSlides;
    var normalizedRightAdj = ((rightAdjacentIndex % totalSlides) + totalSlides) % totalSlides;
    
    if (normalizedIndex === normalizedCenter) {
      $slide.addClass('size-center');
    } else if (normalizedIndex === normalizedLeftAdj || normalizedIndex === normalizedRightAdj) {
      $slide.addClass('size-adjacent');
    } else {
      $slide.addClass('size-outer');
    }
  });
}

// Initialize farm slider
$('.farm-slider').slick({
  centerMode: true,
  centerPadding: '0',
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  // speed: 100,
  dots: true,
  arrows: false,
  cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
  variableWidth: true,
  focusOnSelect: false,
  pauseOnHover: true,
  adaptiveHeight: false,
  waitForAnimate: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        variableWidth: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
        // centerPadding: '20px'
      }
    }
  ]
});

// Event handlers for farm slider
$('.farm-slider').on('init reInit', function() {
  setTimeout(function() {
    updateFarmSlideSizes();
  }, 50);
});

$('.farm-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  // Pre-apply classes for smooth transition
  var $allSlides = $('.farm-slider .slick-slide');
  var $originalSlides = $('.farm-slider .slick-slide:not(.slick-cloned)');
  var totalSlides = $originalSlides.length;
  
  $allSlides.removeClass('size-center size-adjacent size-outer');
  
  var centerIndex = nextSlide;
  var leftAdjacentIndex = (centerIndex - 1 + totalSlides) % totalSlides;
  var rightAdjacentIndex = (centerIndex + 1) % totalSlides;
  
  $allSlides.each(function() {
    var $slide = $(this);
    var slideIndex = parseInt($slide.attr('data-slick-index'));
    
    if (isNaN(slideIndex)) return;
    
    var normalizedIndex = ((slideIndex % totalSlides) + totalSlides) % totalSlides;
    var normalizedCenter = ((centerIndex % totalSlides) + totalSlides) % totalSlides;
    var normalizedLeftAdj = ((leftAdjacentIndex % totalSlides) + totalSlides) % totalSlides;
    var normalizedRightAdj = ((rightAdjacentIndex % totalSlides) + totalSlides) % totalSlides;
    
    if (normalizedIndex === normalizedCenter) {
      $slide.addClass('size-center');
    } else if (normalizedIndex === normalizedLeftAdj || normalizedIndex === normalizedRightAdj) {
      $slide.addClass('size-adjacent');
    } else {
      $slide.addClass('size-outer');
    }
  });
});

$('.farm-slider').on('afterChange', function() {
  updateFarmSlideSizes();
});

// Initial update for farm slider
setTimeout(function() {
  updateFarmSlideSizes();
}, 150);

// Resize handler for farm slider
var farmResizeTimer;
$(window).on('resize', function() {
  clearTimeout(farmResizeTimer);
  farmResizeTimer = setTimeout(function() {
    updateFarmSlideSizes();
  }, 250);
});


document
  .querySelectorAll(".button--add-to-cart.add_to_cart")
  // .querySelectorAll(".button--add-to-cart.add_to_cart:not(.button--add-to-cart.add_to_cart.no-image)")
  .forEach((button) => {
    var valueText = button.disabled;
    var flower = `<img src="https://www.viacitrus.com/cdn/shop/t/35/assets/lemons.png?v=128067643185223438821685477266" width="43" height="31" alt="Add to cart icon" loading="lazy">`
    button.innerHTML = `
    ${button.classList.contains('no-image') ? '' : flower}
    <span class="text">${valueText ? "Sold out" : "Add to cart"}</span>
    <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark">
            <path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"/>
          </svg>
    `;
    // console.log('added success')
  });



  